export const PREMIERE_PRIVATE_PROJECT_METADATA_URI = 'http://ns.adobe.com/premierePrivateProjectMetaData/1.0/';
export const PROPERTY_TYPE_TEXT = 2;

// Mimir specific metadata that we may set on NLE project items. Before
// setting any of these properties, we need to ensure that we register the
// property in the metadata schema of the project of the item.
export const MIMIR_FOLDER_ID_KEY = 'Mimir.Folder.Id';
export const MIMIR_ITEM_ID_KEY = 'Mimir.Item.Id';
export const MIMIR_ARTIFACT_KEY = 'Mimir.Artifact';
export const MIMIR_SUBCLIP_ID_KEY = 'Mimir.Subclip.Id';
export const MIMIR_EXPORT_TIME_KEY = 'Mimir.Sequence.ExportTime';
export const MIMIR_MOGRT_PARENT_ITEM_ID_KEY = 'Mimir.MogrtParentItem.Id';

export const metadataPropertyLabels = {
  [MIMIR_ITEM_ID_KEY]: 'Mimir Item ID',
  [MIMIR_FOLDER_ID_KEY]: 'Mimir Folder ID',
  [MIMIR_EXPORT_TIME_KEY]: 'Mimir Sequence Export Time',
  [MIMIR_SUBCLIP_ID_KEY]: 'Mimir Subclip ID',
  [MIMIR_ARTIFACT_KEY]: 'Mimir Artifact',
  [MIMIR_MOGRT_PARENT_ITEM_ID_KEY]: 'Mimir Mogrt Parent Item ID',
};

// Predefined metadata properties, that we should not register before using.
export const VIDEO_IN_POINT_KEY = 'Column.Intrinsic.VideoInPoint';
export const VIDEO_OUT_POINT_KEY = 'Column.Intrinsic.VideoOutPoint';
export const TAPE_NAME_KEY = 'Column.Intrinsic.TapeName';
export const PROXY_FILE_PATH_KEY = 'Column.Intrinsic.ProxyFilePath';
export const MEDIA_TIMEBASE_KEY = 'Column.Intrinsic.MediaTimebase';
export const MEDIA_DURATION_KEY = 'Column.Intrinsic.MediaDuration';
export const SUBCLIP_DURATION_KEY = 'Column.Intrinsic.SubclipDuration';
export const MEDIA_TYPE_KEY = 'Column.Intrinsic.MediaType';

export const intrinsicMetadataKeys = <const>[
  VIDEO_IN_POINT_KEY,
  VIDEO_OUT_POINT_KEY,
  TAPE_NAME_KEY,
  PROXY_FILE_PATH_KEY,
  MEDIA_TIMEBASE_KEY,
  MEDIA_DURATION_KEY,
  SUBCLIP_DURATION_KEY,
  MEDIA_TYPE_KEY,
];

export type MetadataKey =
  | keyof typeof metadataPropertyLabels
  | typeof intrinsicMetadataKeys[number];
